import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";

type SetProductRecallXParams = {
  formId: string;
  value: string;
};

function SetProductRecallXReducer(
  state: ProposalState,
  { payload: { formId, value } }: PayloadAction<SetProductRecallXParams>,
) {
  state.productByFormId[formId].commercialConditions.recallX = value;
}

export default SetProductRecallXReducer;
